export default "__VITE_ASSET__45b4cb11__"